// Generated by CoffeeScript 1.12.7

/**
Loads an image

@method preloadImage
@param {String|Array} src image uri(s), can take single string or an array
@return {Image|[Image]}
@example
 */
(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    return define('sp/utilities/preload_image',[], factory);
  } else if (typeof module === 'object' && module.exports) {
    return module.exports = factory();
  } else {
    return root.preloadImage = factory();
  }
})(this, function() {
  var preloadImage;
  return preloadImage = function(src) {
    var load;
    load = function(img) {
      var image;
      image = new Image();
      image.src = img;
      return image;
    };
    if (src instanceof Array) {
      return src.map(load);
    } else {
      return load(src);
    }
  };
});

